import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import Avatar from 'components/shared/avatar/component';
import { getPlayersTokenFromCompany } from 'helpers/tokenUtilities';
import { filterOutCompaniesWithNoPlayers } from 'helpers/companyUtilities';
import { CSSTransition } from 'react-transition-group';
import { Trans } from 'react-i18next';
var eyeIcon;
export default function FacilitatorSwitchView() {
    var navigate = useNavigate();
    var players = useSelector(function (state) { return state.general.players; });
    var rawCompanies = useSelector(function (state) { return state.general.companies; });
    var companies = useMemo(function () { return filterOutCompaniesWithNoPlayers(players, rawCompanies); }, [players, rawCompanies]);
    var _a = useState(false), menuOpen = _a[0], setMenuOpen = _a[1];
    var elementRef = useRef(null);
    var switchModalRef = useRef(null);
    function onItemClick(id) {
        setMenuOpen(false);
        if (id) {
            navigate("/join/".concat(getPlayersTokenFromCompany(id, players)));
            return;
        }
        navigate('/facilitator');
    }
    function outsideClickHandler(_a) {
        var target = _a.target;
        if (elementRef.current && !elementRef.current.contains(target)) {
            setMenuOpen(false);
        }
    }
    useEffect(function () {
        document.addEventListener('mousedown', outsideClickHandler);
        eyeIcon = require('assets/img/icons/icon_eye.svg?fill=#ffffff');
        return function () { return document.removeEventListener('mousedown', outsideClickHandler); };
    }, []);
    return (React.createElement("div", { className: "switch", ref: elementRef },
        React.createElement("div", { className: clsx(['switch__icon', menuOpen && 'switch__icon--active']), onClick: function () { return setMenuOpen(!menuOpen); } },
            React.createElement("div", { className: "icon", style: { backgroundImage: "url(".concat(eyeIcon, ")") } })),
        React.createElement(CSSTransition, { in: menuOpen, timeout: 500, classNames: "anim-fade", unmountOnExit: true, nodeRef: switchModalRef },
            React.createElement("div", { className: clsx(['switch__modal']), ref: switchModalRef },
                "          ",
                React.createElement("ul", { className: "switch__list" },
                    companies.map(function (company) { return (React.createElement("li", { className: "switch__item", key: company.id, onClick: function () { return onItemClick(company.id); } },
                        React.createElement(Avatar, { src: company.thumbnail }),
                        React.createElement("div", { className: "flex-grow-1" }, company.name))); }),
                    React.createElement("li", { className: "switch__item switch__item--border", onClick: function () { return onItemClick(); } },
                        React.createElement(Avatar, null),
                        React.createElement("div", { className: "flex-grow-1" },
                            React.createElement(Trans, { i18nKey: "facilitator" }))))))));
}
